export enum CompanyForm {
  Business = 'business',
  SelfEmployed = 'self_employed',
  PersonalUse = 'personal_use',
}
